import React, { useState, useCallback } from 'react'

function LoginBarcode({ onLoginWithBarcode, submitting }) {
  const [barcode, setBarcode] = useState('')

  const handleKeyPress = useCallback(
    async (e) => {
      e.key === 'Enter' && !submitting && onLoginWithBarcode(barcode)
    },
    [submitting, barcode, onLoginWithBarcode]
  )
  const handleClickBarcode = useCallback(
    (e) => {
      e.preventDefault()
      onLoginWithBarcode(barcode)
    },
    [onLoginWithBarcode, barcode]
  )

  return (
    <>
      <div className="form-group">
        <label htmlFor="password">Crachá</label>
        <input
          type="password"
          className="form-control"
          id="password"
          placeholder="senha"
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </div>
      <button
        className="btn btn-primary btn-block"
        type="button"
        onClick={handleClickBarcode}
        disabled={submitting}
      >
        <i className="fa fa-mail" />
        &nbsp;Autenticar com Crachá
      </button>
    </>
  )
}

export default LoginBarcode
